import QuestionnaireSuccess from "./QuestionnaireSuccess";

export default QuestionnaireSuccess;
